<template>
    <div class="cards boxShadow cards-box">
        <div class="cards-detail flex" @click="gotoDetail(datas.id)">
            <el-image
                class="shrink"
                style="width: 60px; height: 60px;margin-right: 10px;"
                :src="datas.headSculptureUrl"
                :fit="'fill'">
            </el-image>
            <div class="cards-detail-name">
                <el-tooltip class="item" effect="dark" :content="datas.nameCn" placement="bottom-start">
                    <p class="overText">{{datas.nameCn?datas.nameCn:'--'}}</p>
                </el-tooltip>
                <div class="flex cards-detail-name-label"> 
                    <span>{{ datas.industryTypeName }}</span> 
                    <span>{{ datas.companyTypeName }}</span> 
                    <span>{{ datas.scaleTypeName }}</span> 
                </div>
            </div>
        </div>
       
        <div class="cards-main ">
            <div style="margin-bottom: 20px;height: 280px;overflow-y: auto;">
                <div class="cards-main-list" v-for="item in datas.positions" :key="item.id">
                    <div class="flexBetween flexNowarp curpoint" @click="gotoPositionDetail(item.id)">
                        <div class="flex itemsCenter">
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom-start">
                                <p class="overText cards-main-name">{{item.name}}</p>
                            </el-tooltip>
                            <div class="flex cards-main-time">
                                <i class="el-icon-refresh-right"></i>
                                <span>反馈时效＞{{item.feedbackAgeing}}天</span>
                            </div>
                        </div>

                        <p class="cards-main-salary shrink">{{item.salaryRangeName}}</p>
                    </div>
                    <div class="flexBetween flexNowarp">
                        <div class="flex flexWarp ">
                            <Btn v-if="item.address" :value="item.address"/> <Btn v-if="item.workExperienceName" :value="item.workExperienceName"/><Btn v-if="item.qualificationsName" :value="item.qualificationsName"  />
                        </div>
                        
                    </div>
                </div>
            </div>
            <MoreBtn :types=1 :id="datas.id"></MoreBtn>
        </div>
    </div>
  </template>
  
  <script>
  import Btn from '../../../components/Btn.vue';
  import MoreBtn from '../../../components/moreBtn.vue'
  export default {
    props: {
        datas:{
            type:Object,
            default:()=>{}
        }
    },
    data() {
      return {
        items:[{id:"1",name:'人力资源'},{id:"2",name:'国企'},{id:'3',name:'10000人以上'}]
      };
    },
    components: {
        Btn,MoreBtn
    },
    methods: {
        gotoDetail(id){
            window.open(`/company/detail?id=${id}`);
        },
        gotoPositionDetail(id){
            window.open(`/job/detail?id=${id}`);
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
.cards {
    border: 1px solid #E2E3EB;
    background-color: $whiteColor;
    width: 410px;
    margin-bottom: 24px;
    
    &-detail{
        padding: 24px 24px 16px;
        border-bottom: 1px solid #EBEBEB;
        cursor: pointer;
        &-name{
            p{
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                color:  $fontCol;
            }
            &-label{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                margin-top: 10px;
                color: $secondfontCol;
                span{
                    padding-right: 25px;
                    position: relative;
                    &:not(:last-child){
                        &::after{
                          content: '';
                          position: absolute;
                          bottom: 2px;
                          right: 10px;
                          width: 1px;
                          height: 14px;
                          background: #D8D8D8;
                        }
                    }
                }
            }
        }

        








      
        
        .flexNowarp{
            margin-bottom: 8px;
            cursor: pointer;
        }
    }
    &-main{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // height: 66%;
        //background: linear-gradient(360deg, rgba(253,253,254,0) 0%, #F9FBFC 100%);
        padding: 16px 24px 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 0px 0px 6px 6px;
        &-list{
            flex-wrap: nowrap;
            //padding: 16px 0;
            // margin-bottom: 24px;
            padding-bottom: 10px;
            border-bottom: 1px solid #EBEBEB;
            &:not(:first-child){
                padding-top: 16px;
            }
            .btn{
                margin-top: 10px;
            }
            .curpoint{
                cursor: pointer;
            }
        }
        &-name{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: $fontCol;
        }
        &-salary{
            color: $yellowColor;
            font-size: 18px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            padding-left: 10px;
        }
        &-time{
            margin-left: 10px;
            margin-right: 10px;
            align-items: center;
            border-radius: 9px;
            height: 18px;
            line-height: 18px;
            border: 1px solid #159C44;
            color: #159C44;
           padding: 0 6px;
            flex-shrink: 0;
            i{
                font-size: 13px;
                color: #159C44;
            }
            span{
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                //color: $secondfontCol;
            }
        }
       
    }
  }
  .cards-box{
    // &:not(:nth-child(3n)){
    //     margin-right: 22px;
    // }
    &:not(:nth-child(3n)){
        margin-right: 22px;
    }
  }
  </style>
  